// from https://discuss.hotwired.dev/t/how-to-return-different-partial-with-hotwire-on-select-dropdwon-change/4571/6
//  This allow updating dynamically a form using POST/PATCH/PUT (submitting it)
//  If it's needed to update using GET, see form_controller
import { Controller } from "@hotwired/stimulus"

//  Accordingly to these verbs, we'll submit or just visit an URL
const SUBMIT_VERBS = ['POST', 'PATCH', 'PUT']

export default class extends Controller {
  static values = {
    url: String,
    name: String,
    verb: String
  }

  connect() {
    // select2 uses jQuery 1.x trigger(), which does not dispatch native DOM events.
    // Stimulus uses addEventListener and never receives the jQuery-triggered change.
    // Register the select2:select listener unconditionally so it works even when
    // select2 is initialized after this controller connects (e.g. via window.load).
    $(this.element).on('select2:select', () => {
      this.element.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  update(event) {
    const url = new URL(this.urlValue);
    url.searchParams.append(this.nameValue, this.element.value);

    SUBMIT_VERBS.includes(this.verbValue && this.verbValue.toUpperCase()) ? event.target.closest('form').requestSubmit() : Turbo.visit(url);
  }
}